export default "__VITE_ASSET__DNQXwurv__"